import { makeStyles, css } from '@conexasaude/conexa-hero'
import noise from '@/assets/noise.png'
import { IS_PRODUCTION } from '@/constants'

const useStyles = makeStyles({
  layoutContainer: theme => css`
    display: flex;
    flex-direction: row;
    position: relative;
    height: ${IS_PRODUCTION ? '100vh ' : `calc(100vh - 32px)`};
    width: 100%;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      flex-direction: column;
    }
  `,

  containerBackground: theme => css`
    position: relative;
    width: 55%;
    height: ${IS_PRODUCTION ? '100vh ' : `calc(100vh - 32px)`};
    display: flex;
    background: linear-gradient(
      -45deg,
      ${theme.colors.brand.primary[300]},
      ${theme.colors.brand.primary[500]}
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `,

  backgroundContentContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
  `,

  backgroundNoise: css`
    position: absolute;
    background-image: url(${noise});
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 100%;
  `,

  backgroundContainerTitle: theme => css`
    text-align: center;
    margin-bottom: ${theme.spacing.xxs};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: 0 ${theme.spacing.xxs};
    }
  `,

  backgroundContainerSubtitle: theme => css`
    text-align: center;
    margin-top: ${theme.spacing.xs};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: 0 ${theme.spacing.xxs};
    }
  `,

  backgroundContainerIcon: theme => css`
    padding: ${theme.spacing.xxs};
    z-index: 1;
    width: 80%;
    max-width: 398px;
    height: min-content;
    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      max-width: 320px;
      width: 100%;
    }
  `,

  contentWrapper: css`
    display: flex;
    align-self: center;
    flex-direction: column;
    flex-shrink: 0;
    width: 100%;
    max-width: 480px;
  `,

  body: ({ spacing, grid }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    overflow-y: auto;
    gap: ${spacing.xxs};
    padding: ${spacing.xs} 62px;
    flex: 1;
    @media (max-width: ${grid.breakpoint.lg}) {
      padding: ${spacing.sm} ${spacing.md} ${spacing.xxs} ${spacing.md};
    }

    @media (max-width: ${grid.breakpoint.md}) {
      padding: ${spacing.sm} ${spacing.sm} ${spacing.xxs} ${spacing.sm};
    }

    @media (max-width: ${grid.breakpoint.sm}) {
      padding: ${spacing.xxs} ${spacing.xs} ${spacing.xs} ${spacing.xs};
    }
  `,

  stepperArea: theme => css`
    display: flex;
    width: 100%;
    max-width: 480px;
    flex-direction: row;
    justify-content: start;
    align-items: start;
    padding-top: ${theme.spacing.xs};
  `,

  contentHeader: theme => css`
    display: flex;
    align-self: center;
    flex-direction: column;
    flex-shrink: 0;
    width: 100%;
    max-width: 480px;
    @media (min-width: ${theme.grid.breakpoint['2xl']}) {
      padding-inline: ${theme.spacing.xs};
    }
  `,

  buttonWrapper: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    flex-grow: 1;
    width: 100%;
  `,

  childrenContainer: css`
    width: 100%;
  `,
  mainCard: theme => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-shrink: 0;
    margin-top: ${theme.spacing.sm};
    @media (min-width: ${theme.grid.breakpoint['2xl']}) {
      padding-inline: ${theme.spacing.sm};
    }
  `,

  contentFooter: theme => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    align-self: center;
    gap: ${theme.spacing.xxs};
    box-sizing: border-box;
    text-align: center;
    position: relative;
    width: 100%;
    max-width: 480px;
    margin-top: ${theme.spacing.sm};
    flex-grow: 1;
    @media (min-width: ${theme.grid.breakpoint['2xl']}) {
      padding-inline: ${theme.spacing.sm};
    }
  `,

  allRightsReserved: theme => css`
    color: ${theme.colors.neutral[200]};
  `,

  supportLink: theme => css`
    display: flex;
    justify-content: center;
    color: ${theme.colors.brand.primary[300]};
    cursor: pointer;
    margin-top: ${theme.spacing.xs};
    @media (min-width: ${theme.grid.breakpoint.lg}) {
      margin-bottom: ${theme.spacing.xs};
    }
  `,
})

export { useStyles }
